import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { requestDeleteUsageGuide } from "./deleteUsageGuide.request";

const useDeleteUsageGuide = (
  options?: MutationOptions<void, ApiServiceError<ApiError>, string>
) => {
  const refetchUsageGuides = useRefetchQuery(["product-usage-guides"]);

  return useMutation({
    mutationFn: requestDeleteUsageGuide,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchUsageGuides();
      toast.success(t("Guide has been deleted successfully"));
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useDeleteUsageGuide;
